import { Col, Row } from 'react-grid-system';
import { useUserLanguage } from '@/customHooks';
import styled from 'styled-components';
import {
  AddressForm,
  CreatePropertyConfirmationDialog,
  CreatePropertySetCommons,
  SelectPropertyOwnerMenu,
  SelectPropertyImagesForm,
  SelectPropertyTypeMenuCard,
  UnitCreateListTable,
} from '../organism';
import textsData from '@/textData/CreatePropertyTexts.json'

type CreateProprertyTemplateProps = {
  currentTemplate: number
}

const TextContainer = styled(Col)`
  text-align: center;
  margin-bottom: 3rem;
`

const ContentContainer = styled(Col)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 4rem;
`

export const CreateProprertyTemplate = ({ currentTemplate }: CreateProprertyTemplateProps) => {
  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  return (
    <>
      <Row>
        <TextContainer>
          <h1>{texts.templateText[currentTemplate].title}</h1>
          <p>{texts.templateText[currentTemplate].description}</p>
        </TextContainer>
      </Row>
      <Row>
        <ContentContainer>
        {
          (() => {
            switch(currentTemplate) {
              case 0:
                return <SelectPropertyTypeMenuCard />
              
              case 1:
                return <CreatePropertySetCommons />

              case 2:
                return <AddressForm />

              case 3:
                return <UnitCreateListTable />

              case 4:
                return <SelectPropertyOwnerMenu />

              case 5:
                return <SelectPropertyImagesForm />

              case 6:
                return <CreatePropertyConfirmationDialog />
              
              default:
                throw new Error('Invalid Current template [CreatePropertyTemplate]')
            }
          })()
        }
        </ContentContainer>
      </Row>
    </>
  )
}
